import React, { ButtonHTMLAttributes } from "react";
import { Container } from "./styles";

interface SecondaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  loading?: boolean;
}

export function SecondaryButton({ text, loading = false, ...rest }: SecondaryButtonProps) {
  return (
    <Container disabled={loading} {...rest}>
      {loading ? <div className="loading" /> : <>{text}</>}
    </Container>
  );
}
